import axios from 'axios'
import moment from 'moment-timezone'

const cacheStoreChart = {
  dataset: {},
  amchart: {}
}

const cacheStore = {
  get: {}
}

function clearAllCache() {
  cacheStore.get = {}
}

if (localStorage.getItem('cacheStore.get'))
  cacheStore.get = JSON.parse(localStorage.getItem('cacheStore.get'))

export const getCache = (method, url) => {
  if (!cacheStore.method) {
    cacheStore.method = {}
  }
  return cacheStore[method][url]
}

export const clearCache = (method, url) => {
  if (cacheStore[method] && cacheStore[method][url])
    delete cacheStore[method][url]
}
export const clearStoreCache = (method, url) => {
  if (cacheStore[method] && cacheStore[method][url])
    console.log(localStorage.removeItem('cacheStore.get'))
  delete cacheStore[method][url]
}

export const get = (url, cache = false, use_token = true, params = {}, minutes = 15) => {
  if (cache) {
    const cachedData = getCache('get', url)
    if (cachedData && cachedData.expire && moment().isBefore(cachedData.expire)) {
      return Promise.resolve(cachedData)
    }

    if (cachedData && cachedData.expire) {
      cachedData.expire = moment().add(1, 'm')
      cacheStore['get'][url] = cachedData
      localStorage.setItem('cacheStore.get', JSON.stringify(cacheStore.get))
    }
  }

  let headers = {
    'Accept': 'application/json'
  }

  if (use_token) {
    const _getToken = getToken()
    headers['Authorization'] = 'Bearer ' + _getToken.access_token
    headers['Serial'] = _getToken.serial
  }


  return axios.get(url, {
    headers: headers,
    params: params
  })
      .then(res => {
        if (cache) {
          res.expire = moment().add(minutes, 'm')
          cacheStore['get'][url] = res
          localStorage.setItem('cacheStore.get', JSON.stringify(cacheStore.get))
        }
        return res
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          logOut()
        }

        if (error && error.response && error.response.status === 500) {
          alert(error.response.data.message || 'Error: server fail')
        }
        return Promise.reject(error)
      })
}
export const post = (url, parameter, use_token = true) => {
  let headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }

  if (use_token) {
    const _getToken = getToken()
    headers['Authorization'] = 'Bearer ' + _getToken.access_token
    headers['Serial'] = _getToken.serial
  }

  return axios.post(url, parameter, {headers: headers})
      .catch(error => {

        if (error && error.response && error.response.status === 401) {
          logOut()
        }

        return Promise.reject(error)
      })
}

export const put = (url, parameter, use_token = true) => {
  let headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }

  if (use_token) {
    const _getToken = getToken()
    headers['Authorization'] = 'Bearer ' + _getToken.access_token
    headers['Serial'] = _getToken.serial
  }

  return axios.put(url, parameter, {headers: headers})
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          logOut()
        }

        return Promise.reject(error)
      })
}

export const deleted = (url, parameter, use_token = true) => {
  let headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }

  if (use_token) {
    const _getToken = getToken()
    headers['Authorization'] = 'Bearer ' + _getToken.access_token
    headers['Serial'] = _getToken.serial
  }

  return axios.delete(url, {headers: headers})
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          logOut()
        }

        return Promise.reject(error)
      })
}

let damping_table = {}
export const damping = (callback, delay = 200, key = null) => {
  if (!key) {
    var err = new Error()
    var token = err.stack.toString().split('\n')
    key = token[1] + '|' + token[2]
  }

  if (damping_table.hasOwnProperty(key)) {
    clearTimeout(damping_table[key])
    delete damping_table[key]
    // console.log('Cancel ' + key)
    // console.log(__caller__)
  }
  damping_table[key] = setTimeout(function() {
    // console.log('Exec ' + key)
    callback()
  }, delay)

}

export const setting = {
  logistic: {
    getReportOptionAPI: '/api/reports/logistic_report_option'
  },
  location: {
    locate: '/api/location/locate?keyword={keyword}'
  },
  customer: {
    getListAPI: '/api/customers',
    getResourceAPI: '/api/customers/{id}',
    getOrderAPI: '/api/customers/{id}/orders',
    getProductsAPI: '/api/customers/{id}/products',
    getAddressAPI: '/api/customers/{id}/addresses',
    getStatAPI: '/api/customers/{id}/stat',
    getTimelineAPI: '/api/customers/{id}/timeline',
    getCartAPI: '/api/customers/{id}/cart'
  },
  overview: {
    getListAPI: '/api/overview'
  },
  config: {
    getListAPI: '/api/config'
  },
  user: {
    getListAPI: '/api/users',
    getResourceAPI: '/api/users/{id}',
    getOrderAPI: '/api/users/{id}/orders'
  },
  campaign: {
    getListAPI: '/api/campaigns',
    getListAdminAPI: '/api/campaigns_admin',
    getResourceAPI: '/api/campaigns/{id}',
    getWithPromotionsAPI: '/api/campaigns/{id}/with_promotions',
    getPromotionAPI: '/api/campaigns/{id}/promotions'
  },
  promotion: {
    getListAPI: '/api/promotions',
    getListAdminAPI: '/api/promotions_admin',
    getResourceAPI: '/api/promotions/{id}',
    getProductAPI: '/api/promotions/{id}/products'
  },
  product_promotion: {
    getListAPI: '/api/product_promotions',
    getResourceAPI: '/api/product_promotions/{id}'
  },
  truck: {
    getListAPI: '/api/trucks',
    // getListAdminAPI: '/api/trucks_admin',
    getResourceAPI: '/api/trucks/{id}'
    // getWithPromotionsAPI: '/api/trucks/{id}/with_promotions',
    // getPromotionAPI: '/api/trucks/{id}/promotions'
  },
  line_stream: {
    getListAPI: '/api/line_stream',
    getResourceAPI: '/api/line_stream/{id}'
  },
  transportRoute: {
    getListAPI: '/api/transport_route',
    // getListAdminAPI: '/api/trucks_admin',
    getResourceAPI: '/api/transport_route/{id}'
    // getWithPromotionsAPI: '/api/trucks/{id}/with_promotions',
    // getPromotionAPI: '/api/trucks/{id}/promotions'
  },
  customer_address: {
    getListAPI: '/api/customer_address',
    // getListAdminAPI: '/api/trucks_admin',
    getResourceAPI: '/api/customer_address/{id}'
    // getWithPromotionsAPI: '/api/trucks/{id}/with_promotions',
    // getPromotionAPI: '/api/trucks/{id}/promotions'
  },
  route: {
    getListAPI: '/api/routes',
    getResourceAPI: '/api/routes/{id}'
  },
  province: {
    getListAPI: '/api/provinces',
    getResourceAPI: '/api/provinces/{id}'
  },
  product: {
    getListAPI: '/api/products',
    getResourceAPI: '/api/products/{id}'
  },
  order: {
    getListAPI: '/api/orders',
    getResourceAPI: '/api/orders/{id}',
    approvingAPI: '/api/orders/{id}/approving'
  },
  destination: {
    getListAPI: '/api/destinations',
    getResourceAPI: '/api/destinations/{id}'
  },
  shipping: {
    getListAPI: '/api/shipping',
    getResourceAPI: '/api/shipping/{id}'
  },
  timeline: {
    getListAPI: '/api/timeline',
    getResourceAPI: '/api/timeline/{id}'
  },
  order_user: {
    getListAPI: '/api/order_user',
    getResourceAPI: '/api/order_user/{id}'
  },
  item: {
    getListAPI: '/api/items',
    getResourceAPI: '/api/items/{id}'
  },
  carts: {
    getListAPI: '/api/carts'
  },
  district: {
    getListAPI: '/api/districts'
  },
  city: {
    getListAPI: '/api/cities'
  },
  slip: {
    getListAPI: '/api/slips',
    getResourceAPI: '/api/slips/{id}'
  },
  setting: {
    getListAPI: '/api/setting',
    getResourceAPI: '/api/setting/{id}'
  },
  business: {
    getListAPI: '/api/business'
  },
  media: {
    getListAPI: '/api/media',
    getResourceAPI: '/api/media/{id}'
  }
}

export const setToken = (token) => {
  localStorage.setItem('token', JSON.stringify(token))
  currentToken = token
}

let currentToken = null
export const getToken = () => {
  if (!currentToken) {
    let token = localStorage.getItem('token')

    if (token != null) {
      // console.info('Token : ', token)
      token = JSON.parse(token)
      currentToken = token
      // console.info('Token : ', token)
    } else {
      //token = {access_token: null}
    }
    return token
  } else {
    return currentToken
  }
}


export let access_token = () => (getToken() || {access_token: null}).access_token

export const checkLogin = () => {
  return getToken() !== null
}
export const logOut = (reload = true) => {
  localStorage.clear()
  clearAllCache()
  if (reload) {
    window.location.reload()
  }
}
export const number_format = (number, prefer_digit = null, max_digit = null) => {
  if (number === 'n/a') return number
  if (prefer_digit === null) {
    return new Intl.NumberFormat('th-TH', {maximumFractionDigits: 2}).format(number)
  } else {
    if (max_digit == null) max_digit = prefer_digit
    return new Intl.NumberFormat('th-TH', {
      minimumFractionDigits: prefer_digit,
      maximumFractionDigits: max_digit
    }).format(number)
  }
}
export const date_format_mysql = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  return moment(normalizeDate(datetimeStr)).format('YYYY-MM-DD HH:mm:ss')
}
export const date_format_short_with_time = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  // console.log(dateTimeFormat.formatToParts(date))
  return `${day} ${month}  ${('00' + date.getHours()).slice(-2)}:${('00' + date.getMinutes()).slice(-2)}`
}
export const date_format_short_with_year_time = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: '2-digit', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${day} ${month} ${year} ${('00' + date.getHours()).slice(-2)}:${('00' + date.getMinutes()).slice(-2)}`
}

export const date_format_time = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${('00' + date.getHours()).slice(-2)}:${('00' + date.getMinutes()).slice(-2)}`
}

export const date_format = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${day} ${month} ${year}`
}

export const date_format_short_with_year = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: '2-digit', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${day} ${month} ${year}`
}

export const date_format_short = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${day} ${month}`
}
export const day_format_short = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${day}`
}

export const month_format_short = (datetimeStr) => {
  if (datetimeStr === null || datetimeStr === undefined) return 'n/a'
  const date = new Date(normalizeDate(datetimeStr))
  const dateTimeFormat = new Intl.DateTimeFormat('th', {year: 'numeric', month: 'short', day: '2-digit'})
  const [{value: day}, , {value: month}, , {value: year}] = dateTimeFormat.formatToParts(date)
  return `${month} ${('' + year).slice(-2)}`
}
const normalizeDate = (datetimeStr) => {
  if (datetimeStr instanceof Date) {
    datetimeStr = moment(datetimeStr).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
  }
  return datetimeStr
}
export const parseMonth = (monthEng) => {
  switch (monthEng) {
    case 'Jan':
      return 'ม.ค.'
    case 'Feb':
      return 'ก.พ.'
    case 'Mar':
      return 'มี.ค.'
    case 'Apr':
      return 'เม.ย.'
    case 'May':
      return 'พ.ค.'
    case 'Jun':
      return 'มิ.ย.'
    case 'Jul':
      return 'ก.ค.'
    case 'Aug':
      return 'ส.ค.'
    case 'Sep':
      return 'ก.ย.'
    case 'Oct':
      return 'ต.ค.'
    case 'Nov':
      return 'พ.ย.'
    case 'Dec':
      return 'ธ.ค.'
    case 'Loading':
      return 'Loading'
  }
  return ''
}
export const parseNoMonth = (monthNo) => {
  const monthMap = {
    1: 'ม.ค.',
    2: 'ก.พ.',
    3: 'มี.ค.',
    4: 'เม.ย.',
    5: 'พ.ค.',
    6: 'มิ.ย.',
    7: 'ก.ค.',
    8: 'ส.ค.',
    9: 'ก.ย.',
    10: 'ต.ค.',
    11: 'พ.ย.',
    12: 'ธ.ค.'
  }
  return monthMap.hasOwnProperty(monthNo) ? monthMap[monthNo] : monthNo
}

export const parseDate = (dateStr) => {
  const date = new Date(Date.parse(dateStr))
  return date.toLocaleString('th-TH', {
    weekday: 'short',
    year: '2-digit',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })

  // .toLocaleDateString('th-TH', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
}

export const parseUnit = (unitKey) => {

  const unitMap = {
    BT: 'ขวด',
    CAR: 'คัน',
    COU: 'คู่',
    CTN: 'หีบ',
    DR: 'ดั้ม',
    G: 'กรัม',
    GAL: 'แกลฯ',
    KG: 'กิโลฯ',
    L: 'ลิตร',
    ML: 'มล.',
    PCS: 'ชิ้น',
    PK: 'แพ็ค',
    ROL: 'ม้วน',
    SA: 'กระสอบ',
    SET: 'ชุด',
    SH: 'ผืน',
    SL: 'อัน',
    TANK: 'ถัง',
    Unit: 'หน่วย'
  }
  return unitMap.hasOwnProperty(unitKey) ? unitMap[unitKey] : unitKey
}

const Helper = {
  access_token,
  get,
  post,
  put,
  deleted,
  setting,
  damping,
  setToken,
  getToken,
  checkLogin,
  logOut,
  number_format,
  parseMonth,
  parseNoMonth,
  day_format_short,
  date_format_mysql,
  date_format,
  date_format_short_with_year_time,
  date_format_short_with_year,
  date_format_short_with_time,
  date_format_time,
  date_format_short,
  month_format_short,
  clearCache,
  clearAllCache,
  clearStoreCache,
  getCache,
  parseDate,
  parseUnit
}

export default Helper
